import axios from "@/api/axios";
import qs from "qs";

const gameDataList = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    pageno: 1,
    pagesize: 10,
    gamelistcnt: "0",
    gamelist: [],
  };
  const options = {
    method: "POST",
    url: "/manager/gamedataset1",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(params),
    //params: params
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(null);
    }
  });
};

const gameDataScore = async (gameno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    playerlistcnt: "0",
    playerlist: [],
  };
  const options = {
    method: "GET",
    url: "/manager/gamedataset2/" + gameno,
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(null);
    }
  });
};

const gameOneShot = async (gameno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    shotlistcnt: "0",
    shotlist: [],
  };
  const options = {
    method: "GET",
    url: "/manager/gamedataset3/" + gameno,
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(response.data);
    }
  });
};

const gameInfo = async (gameno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    playerlistcnt: "0",
    playerlist: [],
  };
  const options = {
    method: "GET",
    url: "/manager/gamedataset4/" + gameno,
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(null);
    }
  });
};

const get_correctionlist = async (params, result) => {
  let finalData = {
    code: 200,
    message: "",
    pageno: 1,
    pagesize: 10,
    correctionlistcnt: "0",
    correctionlist: [],
  };
  const options = {
    method: "GET",
    url: "/manager/correctionlist",
    params: {
      startdate: params.startdate,
      enddate: params.enddate,
      searchtype: params.searchtype,
      searchname: params.searchname,
      type: params.type,
      status: params.status,
      pageno: params.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_correctionlist", err);
    result(false, err);
  }
};

//
const get_scorecard = async (player_pk, define1_pk, result) => {
  let finalData = {
    code: 200,
    message: "",
    subcourselist: [],
  };
  const options = {
    method: "GET",
    url: "/manager/scorecard/" + player_pk + "/" + define1_pk,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_tournamentcondition", err);
    result(false, err);
  }
};

const get_correctionfile = async (player_pk, define1_pk, result) => {
  let finalData = {
    code: 200,
    message: "",
    score: [],
    shot: [],
    s3_key: "",
    parse: null,
  };
  const options = {
    method: "GET",
    url: "/manager/correctionfile/" + player_pk + "/" + define1_pk,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_correctionfile", err);
    result(false, err);
  }
};

const set_pending = async (define1_pk, sendData, result) => {
  let finalData = {
    code: 0,
    message: "",
  };

  const options = {
    method: "POST",
    url: "/manager/pending/" + define1_pk,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(sendData),
    //params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const set_reprocess = async (define1_pk, sendData, result) => {
  let finalData = {
    code: 0,
    message: "",
  };

  const options = {
    method: "POST",
    url: "/manager/reprocess/" + define1_pk,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(sendData),
    //params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const set_delete_flag = async (define1_pk, player2_pk, delete_flag, result) => {
  let finalData = {
    code: 0,
    message: "",
  };

  const options = {
    method: "POST",
    url:
      "/postact/gamedatadelete/" +
      define1_pk +
      "/" +
      player2_pk +
      "/" +
      delete_flag,
    // headers: {'Content-Type': 'application/x-www- form-urlencoded'},

    //params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

export default {
  gameDataList,
  gameDataScore,
  gameOneShot,
  gameInfo,
  get_correctionlist,
  get_scorecard,
  get_correctionfile,
  set_pending,
  set_reprocess,
  set_delete_flag,
};
